<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="打印发料单"
      class="printIssue"
      width="900px"
      top="0">
    <div id="printContent">
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tr>
          <td class="ewm" rowspan="3">
            <div id="qrCode" align="center"/>
          </td>
          <td colspan="7" style="text-align: center; font-weight: 700; font-size: 14px">发料单</td>
        </tr>
        <tr>
          <td colspan="3">工单编号：{{orderInfo.productionOrderNo}}</td>
          <td colspan="3">派工单号：{{orderInfo.billNo}}</td>
        </tr>
        <tr>
          <td colspan="3">工单类型：{{orderInfo.prodOrderTypeName}}</td>
          <td colspan="3">物料编号：{{orderInfo.materialNo}}</td>
        </tr>
        <tr>
          <td colspan="4">工单数量：{{orderInfo.quantity}}</td>
          <td colspan="4">单位：{{orderInfo.unitName}}</td>
        </tr>
        <tr>
          <td colspan="4">规格：</td>
          <td colspan="4">物料名称：{{orderInfo.materialName}}</td>
        </tr>
        <tr>
          <td colspan="4">工作中心：{{orderInfo.workCenterName}}</td>
          <td colspan="4">工艺路线：{{orderInfo.routingName}}</td>
        </tr>
        <tr>
          <td colspan="4">开工时间：{{orderInfo.planStartTime}}</td>
          <td colspan="4">完工时间：{{orderInfo.planFinishTime}}</td>
        </tr>
        <tr>
          <td colspan="4">销售单号：{{orderInfo.salesOrderNo}}</td>
          <td colspan="4">ERP单号：{{orderInfo.erpSalesOrderNo}}</td>
        </tr>
        <tr>
          <td colspan="4">合同号：{{orderInfo.customerContractNo}}</td>
          <td colspan="4">项目名称：{{orderInfo.projectName}}</td>
        </tr>
        <tr>
          <td colspan="8">客户名称：{{orderInfo.customerName}}</td>
        </tr>
      </table>
      <el-table style="margin-top:20px" :data="orderInfo.bomList" border align="left">
        <el-table-column prop="materialNo" align="left" label="物料编号" width="150"/>
        <el-table-column prop="materialName" align="left" label="物料名称"/>
        <el-table-column prop="quantity" align="center" label="需求数量" width="120"/>
        <el-table-column prop="" align="center" label="实发数量" width="120"/>
        <el-table-column prop="unitName" align="center" label="单位" width="80"/>
      </el-table>
    </div>
    <span slot="footer">
      <el-button @click="dialogVisible = false">关闭</el-button>
      <el-button type="primary" @click="print">打印</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import QRCode from "qrcodejs2";
  export default {
    data() {
      return {
        orderInfo: {},
        dialogVisible: false,
      };
    },

    methods: {
      open(orderInfo) {
        this.orderInfo = orderInfo;
        this.dialogVisible = true;
        const item = this.orderInfo.billNo;
        this.$nextTick(() => {
          document.getElementById("qrCode").innerHTML = "";
          this.bindQRCode(item);
        });
      },

      bindQRCode(row) {
        let text = row;
        new QRCode(document.getElementById("qrCode"), {
          text: text,
          width: 120,
          height: 120,
          colorDark: "#333333", //二维码颜色
          colorLight: "#ffffff", //二维码背景色
          correctLevel: QRCode.CorrectLevel.L, //容错率，L/M/H
        });
      },

      print() {
        document.body.innerHTML = document.getElementById("printContent").parentNode.innerHTML;
        window.print();
        window.location.reload();
        return false;
      },
    },
  };
</script>
<style lang="scss" scoped>
.printIssue .el-dialog__header {
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 99999;
  box-sizing: border-box;
}
.printIssue .el-dialog__footer {
  position: fixed;
  width: 100%;
  bottom: 0;
  z-index: 99999;
  box-sizing: border-box;
  background-color: #fff;
}

.printIssue .el-dialog {
  margin: 2% auto !important;
  transform: scale3d(1, 1, 1);
  padding-top: 30px;
  padding-bottom: 69px;
  height: 90%;
}

.printIssue .el-divider--horizontal {
  margin: 10px 0;
}

.printIssue .el-dialog .el-dialog__body {
  height: 100%;
  background-color: #fff;
  overflow: scroll;
}
</style>

<style scoped>
td {
  border: 1px solid #EBEEF5;
  border-right: 0;
  border-bottom: 0;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  box-sizing: border-box;
  min-width: 200px;
  font-size: 12px;
}
tr td:last-child {
  border-right: 1px solid #EBEEF5;
}
tr:last-child td {
  border-bottom: 1px solid #EBEEF5;
}
.ewm {
  width: 120px;
  min-width: 120px;
  padding: 10px;
}
</style>
